import { Middleware } from '@reduxjs/toolkit'

function isErrorAction(
  action: unknown
): action is { payload: { status: string } } {
  if (typeof action === 'object' && action !== null && 'payload' in action) {
    const payload = (action as Record<string, unknown>).payload
    return (
      typeof payload === 'object' && payload !== null && 'status' in payload
    )
  }
  return false
}

export const authMiddleware: Middleware = () => (next) => (action: unknown) => {
  // Only do the fetch check if the action is an error
  if (isErrorAction(action) && action.payload?.status === 'FETCH_ERROR') {
    const ideyaApiUrl = location.protocol + '//' + location.host + '/'
    fetch(`${ideyaApiUrl}cdn-cgi/access/get-identity`, {
      credentials: 'include',
    }).then((res) => {
      if (res.status !== 200) {
        window.location.reload()
      }
    })
  }

  return next(action)
}
